import * as React from 'react';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import * as styles from './report.module.scss';
import { datadogRum } from '@datadog/browser-rum';

interface Props {
  viz: any;
  anchorEl: HTMLElement;
  setAnchorEl: () => void;
  /** name of the dashboard the button is associated with */
  dashboard: string;
}

/**
 * Render dropdown for export button
 */
const ExportDropdown = ({ viz, anchorEl, setAnchorEl, dashboard }: Props) => {
  return (
    <Menu
      className={styles.exportMenu}
      anchorEl={anchorEl}
      open={Boolean(anchorEl)}
      onClose={() => setAnchorEl()}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'center'
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'center'
      }}
    >
      <MenuItem
        className={styles.menuItem}
        onClick={async () => {
          setAnchorEl();
          await viz.displayDialogAsync('export-pdf');
          datadogRum.addUserAction('export-menu-option', {
            user_action_details: {
              type: 'tableau_toolbar',
              name: 'export-menu-option',
              option: 'pdf',
              dashboard_name: dashboard
            }
          });
        }}
      >
        PDF
      </MenuItem>
      <MenuItem
        className={styles.menuItem}
        onClick={async () => {
          setAnchorEl();
          await viz.displayDialogAsync('export-data');
          datadogRum.addUserAction('export-menu-option', {
            user_action_details: {
              type: 'tableau_toolbar',
              name: 'export-menu-option',
              option: 'raw',
              dashboard_name: dashboard
            }
          });
        }}
      >
        Raw Data
      </MenuItem>
      <MenuItem
        className={styles.menuItem}
        onClick={async () => {
          setAnchorEl();
          await viz.exportImageAsync();
          datadogRum.addUserAction('export-menu-option', {
            user_action_details: {
              type: 'tableau_toolbar',
              name: 'export-menu-option',
              option: 'image',
              dashboard_name: dashboard
            }
          });
        }}
      >
        Image
      </MenuItem>
      <MenuItem
        className={styles.menuItem}
        onClick={async () => {
          setAnchorEl();
          await viz.displayDialogAsync('export-cross-tab');
          datadogRum.addUserAction('export-menu-option', {
            user_action_details: {
              type: 'tableau_toolbar',
              name: 'export-menu-option',
              option: 'crossTab',
              dashboard_name: dashboard
            }
          });
        }}
      >
        CrossTab
      </MenuItem>
    </Menu>
  );
};

export default ExportDropdown;
